import { Avatar, ClickAwayListener, List, ListItem, ListItemAvatar, ListItemText, Paper, Popper } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import HtmlUtils from 'lib/HtmlUtils';
import * as React from 'react';
import { othersStyles } from './OthersCommon';

//////////////////////////////////////////////////////////////////////////////////////

interface IPropsList {
    topics: Array<any>;
    onClose: () => void;
}


interface IProps extends IPropsList {
    anchor: any;
}

//////////////////////////////////////////////////////////////////////////////////////

type OtherListProps = IPropsList & WithStyles<typeof othersStyles>;

class OtherTopicFollowingListComponent extends React.PureComponent<OtherListProps> {

    render() {

        return (
            <ClickAwayListener
                onClickAway={() => this.props.onClose()}
            >

                <List
                    classes={{ root: this.props.classes.listRoot }}
                    disablePadding
                >
                    {
                        this.props.topics.map((v, index) => (
                            <ListItem
                                button
                                disableGutters
                                style={{ padding: 0 }}
                                key={index}
                                onClick={() => HtmlUtils.openUrlInNewWindow(v.ViewUrl, v.TopicId)}
                            >
                                <ListItemAvatar style={{ minWidth: 30 }}>
                                    <Avatar src={v.ThumbnailUrl} alt={v.Name} style={{ height: 24, width: 24 }} />
                                </ListItemAvatar>
                                <small><ListItemText primary={v.Name} primaryTypographyProps={{ variant: "body2" }} /></small>
                            </ListItem>
                        ))
                    }
                </List>

            </ClickAwayListener>
        );
    }
}

export const OtherTopicFollowingList = withStyles(othersStyles)(OtherTopicFollowingListComponent);

//////////////////////////////////////////////////////////////////////////////////////


type OtherProps = IProps & WithStyles<typeof othersStyles>;

class OtherTopicFollowing extends React.PureComponent<OtherProps> {

    render() {

        return (
            <Popper
                disablePortal={false}
                open={true}
                anchorEl={this.props.anchor}
                style={{ zIndex: 130000 }}
            >
                <ClickAwayListener
                    onClickAway={() => this.props.onClose()}
                >

                    <Paper>
                        <List
                            classes={{ root: this.props.classes.listRoot }}
                        >
                            {
                                this.props.topics.map((v, index) => (
                                    <ListItem
                                        button
                                        key={index}
                                        onClick={() => HtmlUtils.openUrlInNewWindow(v.ViewUrl, v.TopicId)}

                                    >
                                        <Avatar title={v.Name} >
                                            <img src={v.ThumbnailUrl} alt={v.Name} height={32} width={32} />
                                        </Avatar>
                                        <ListItemText primary={v.Name} primaryTypographyProps={{ variant: "body2" }} />
                                    </ListItem>
                                ))
                            }
                        </List>
                    </Paper>

                </ClickAwayListener>
            </Popper >
        );
    }
}

export default withStyles(othersStyles)(OtherTopicFollowing);

